import gql from "graphql-tag";
import { AvailableCompanies, AvailableCompanies_availableCompanies } from "@/models/queries/types/AvailableCompanies";

export const AVAILABLE_COMPANIES_QUERY = gql`
  query AvailableCompanies {
    availableCompanies {
      shortcut
      name
      reportNumberPrefix
      restrictAccess
    }
  }
`;

export type AvailableCompaniesResult = AvailableCompanies;
export type Company = AvailableCompanies_availableCompanies;
